import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 3rem 2rem;
  text-align: center;

  button {
    display: inline-block;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-content: stretch;
  gap: 0.75rem;
  padding: 0 2rem;
`;
